<template>
  <div class="">
    <div class="wrap">
      <img  :src="imgUrl" @click="show = !show">
      <span v-if="isShowClose" class="delete-comment-img-btn">
        <i  @click="clear" class=" close iconfont icon-quxiao"></i>
      </span>
    </div>
    <van-image-preview
      v-model="show"
      :images="[imgUrl]"/> 
  </div>
</template>

<script>
export default {
  name: 'previewImg',
  props: {
    isShowClose: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    clear() {
      this.$emit('clear')
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .delete-comment-img-btn {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 14px;
    height: 14px;
    background: #666666;
    color: #fff;
    line-height: 14px;
    text-align: center;
    border-radius: 50%;
    .icon-quxiao {
      font-size: 12px;
      top: -1px;
      position: relative;
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

</style>
